/* eslint-disable react-hooks/exhaustive-deps */
import React, { useEffect, useState } from 'react';
import { MdAnnouncement } from 'react-icons/md';
import { useSelector } from 'react-redux';

import Skeleton from '@material-ui/lab/Skeleton';

import OverflowText from '~/components/OverflowText';
import { IState } from '~/store';

import { FixedDetail } from '../FixedDetails';
import ProcessDetails from '../ProcessDetails';
import MenuInstances, { InstanceLink } from './MenuInstances';
import { StatusSubtitleProps } from './MenuInstances/StatusSubtitle';
import {
  Container,
  EmptyContainer,
  ProcessDetailsContainer,
  ProcessDetailsHeader,
} from './styles';

export interface DetailsParametrizedProps {
  pathToEntity: string;
  pathToInstance: string;
  pathToLoading: string;
  find: (instance: InstanceLink) => void;
}

export interface ListParametrizedProps extends DetailsParametrizedProps {
  find: () => void;
}

export interface InstanceDetailsProps<Type> {
  getfixedDetails: (data: Type) => Array<FixedDetail>;
  instanceDetails: DetailsParametrizedProps;
  instanceList: ListParametrizedProps;
  statusProps: StatusSubtitleProps;
  parentLoading?: boolean;
}

function InstanceDetails<Type>({
  getfixedDetails,
  instanceDetails,
  instanceList,
  statusProps,
}: InstanceDetailsProps<Type>) {
  const [activeInstance, setActiveInstance] = useState<
    InstanceLink | undefined
  >(undefined);

  const list: Array<InstanceLink> = useSelector(
    (state: IState) =>
      (state as any)[instanceList.pathToEntity][instanceList.pathToInstance],
  );

  const loadingList = useSelector(
    (state: IState) =>
      (state as any)[instanceList.pathToEntity][instanceList.pathToLoading],
  );

  const instance: Type = useSelector(
    (state: IState) =>
      (state as any)[instanceDetails.pathToEntity][
        instanceDetails.pathToInstance
      ],
  );

  const loading = useSelector(
    (state: IState) =>
      (state as any)[instanceDetails.pathToEntity][
        instanceDetails.pathToLoading
      ],
  );

  const getActiveInstanceTitle = () => {
    return (
      list?.find((instance) => instance.id === activeInstance?.id)?.name ??
      'Sem Título'
    );
  };

  const renderInstances = () => (
    <Container>
      <MenuInstances
        loading={loadingList}
        instances={list}
        activeInstance={activeInstance}
        handleChangeActiveInstance={(newInstance) =>
          setActiveInstance(newInstance)
        }
        statusProps={statusProps}
      />
      <ProcessDetailsContainer>
        <ProcessDetailsHeader>
          {loadingList ? (
            <Skeleton height={32} width={300} />
          ) : (
            <OverflowText title={getActiveInstanceTitle()} lines={2}>
              {getActiveInstanceTitle()}
            </OverflowText>
          )}
        </ProcessDetailsHeader>
        <ProcessDetails
          process={instance}
          fixedDetails={getfixedDetails(instance)}
          loading={loadingList || loading}
          numberOfColumns={2}
        />
      </ProcessDetailsContainer>
    </Container>
  );

  const renderEmptyContainer = () => (
    <EmptyContainer>
      <MdAnnouncement size={120} color="#c1c1c1" />
      As execuções estarão aqui
    </EmptyContainer>
  );

  useEffect(() => {
    if (activeInstance) {
      instanceDetails.find(activeInstance);
    }
  }, [activeInstance?.id]);

  useEffect(() => {
    if (!list || list?.length < 1) {
      setActiveInstance(undefined);
    } else if (!activeInstance) {
      setActiveInstance(list[0]);
    }
  }, [list]);

  useEffect(() => {
    instanceList.find();
  }, []);

  return loadingList || (list && list.length > 0)
    ? renderInstances()
    : renderEmptyContainer();
}

export default InstanceDetails;
